// HACK: Phase4Step2-2終了間際にESLintのルールが変更になり、ロジックは変更出来なかったため回避。
/* eslint-disable max-lines */
// about vuex
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { mapState, mapActions } from 'vuex';
import api from '../../../common/api';
import config from '../../../share/config';
import service from '../../../share/util/api/service';
import handler from '../../../share/util/apiResultValidator';
import util from '../../../share/util/utils';
import alert from '../../../share/alert';
import loading from '../../../share/components/vue/ProcessingIcon';
import cstmTable from '../../../share/components/vue/PaginationTable';
import cstmCard from "../../../share/components/vue/CustomCard";
import svgButton from '../../../share/components/vue/SVGButton';
import exam from '../../../share/util/inputValidator';
import diagnoResource from '../../../share/util/diagnose';
import customProgress from "../../../share/components/vue/CustomProgress";
import atUtil from "../../pages/individualActiveTest/individualActiveTestUtil";
import { createInitialActiveLabel, createTabName, FUNCTION_CONFIGS } from './functionConfigs';
import dmUtil from "../../pages/dataMonitor/dataMonitorUtil";
import { CsvFileWriter, getMeasurementFileName } from '../../pages/dataMonitor/dataMonitorFileUtil';
import { getSystemNameIsSpecial } from '../../../share/util/resourceMap';
import { setMeasuresDisplaySystemName } from "./measuresUtils";
import dataRecollection from '../../vue/DataRecollection';
import constants from '../../../common/nodejs/constants';

const PROJECTS = '/projects/';

export default {
  name: "diagProjectList",
  data() {
    return {
      processing: false,
      modalLoading: false,
      projectDetails: {},
      originalComment: '',
      detailsColumns: [
        { name: 'name', label: 'message.label_measured_data_details_data_name' },
        { name: 'updated_at', label: 'message.label_measured_data_details_update_time' },
        { name: 'note', label: 'message.label_measured_data_details_notes' },
        { name: 'edit', label: 'message.label_measured_data_details_edit', useButton: true }
      ],
      detailsDataTable: [],                        // 画面表示用のでテーブルデータ
      reproDetailsData: [],                        // (全DTC,DTC,レディネスコード)取得データ
      allDtcMeasuresData: [],                      // 全DTCデータ取得データ
      diagCodeMeasuresData: [],                    // DTCデータ取得データ
      readinessMeasuresData: [],                   // レディネスコードデータ取得データ
      vchMeasuresData: [],                         // 制御作動履歴データ取得データ
      cstMeasuresData: [],                         // カスタマイズデータ取得データ
      cncMeasuresData: [],                         // キャンセルコードデータ取得データ
      wspMeasuresData: [],                         // 作業サポートデータ取得データ
      dmatDetailsData: [],                         // データモニタ,アクティブテストデータ取得データ
      obdDetailsData: [],                          // OBD対象機能取得データ
      obdAllDtcMeasuresData: [],                   // OBD 全DTC取得データ
      obdOnBoardMonitorTestMeasuresData: [],       // OBD オンボードモニタ取得データ
      obdDataMonitorMeasuresData: [],              // OBD データモニタ取得データ
      obdDiagCodeMeasuresData: [],                 // OBD DTC取得データ
      obdPermanentDiagCodeMeasuresData: [],        // OBD パーマネントDTC取得データ
      obdVehicleInfoMeasuresData: [],              // OBD 車両情報取得取得データ
      obdIumprMeasuresData: [],                    // OBD 診断頻度取得データ
      obdReadinessStatusMeasuresData: [],          // OBD レディネスステータス取得データ
      selectedData: null,
      selectedUpdatedTime: null,
      filledDataName: null,
      filledDataNote: null,
      isAlert: {},
      displayTabLabelList: [], // タブ表示用配列
      activeLabel: createInitialActiveLabel(),  //タブ表示に必要な値
      initApiFlg: true,  // 初期表示のみAPI実行を行うフラグ
      eventLogItems: [],                            // イベントログ一覧表示
      rprJobId: null,                               // リプロジョブID
      macJobId: null,                               // MAC鍵ジョブID
      imbJobId: null,                               // イモビジョブID
      url: '',                                      // Presigned URL
      modalEdit: false,
      rprEventLogListResult: [],
      imbEventLogListResult: [],
      macEventLogListResult: [],
      isSBRUser: false,
      indDmMeasuresData: [],                        // データモニタ取得データ
      mltDmMeasuresData: [],                        // マルチデータモニタ取得データ
      atMeasuresData: [],                           // アクティブテスト取得データ
      indCstMeasuresData: [],                       // カスタマイズ取得データ
      allCstMeasuresData: [],                       // 全カスタマイズ取得データ
      vinType: '',                                  // vinタイプ
      isLeave: false,                               // 既に画面を離れているかどうかのフラグ（ブラウザバック時の判定に使用）
      allMeasuresData: null,
      measuredIdProp: null,
      isActive: null,
      systemName: null,
      systemIds: null,
      itemNameProp: null,
      obdDataIdProp: null,
      obdSystemsProp: null,
      activeDataRecollection: false,
      selectedRow: null,
      dataSourceHeader: {},                         // 計測データの取得元の環境(マスター/ミラー)
      showCsvProgress: false,                       // CSVエクスポート中のプログレスバー表示フラグ
      exportPercentage: 0,                          // CSVエクスポート進捗率
    };
  },

  watch: {
    language() {
      this.setNavTabLabel();
      if (this.isSBRUser) {
        this.createEventLogItemsRpr();
        this.createEventLogItemsImb();
        this.createEventLogItemsMac();
      }
      // 計測データ一覧の特殊機能表示の表示値の再設定
      setMeasuresDisplaySystemName(
        this,
        this.currentFunctionKey,
        this.diagCodeMeasuresData,
        this.vchMeasuresData,
        this.cncMeasuresData,
        this.indDmMeasuresData,
        this.atMeasuresData,
      );
      this.getMultipleDMSystemName();
      this.setDataSourceHeader();
    },
  },

  components: {
    'processing-view': loading,
    'cstm-card': cstmCard,
    'svg-button': svgButton,
    'cstm-tbl': cstmTable,
    'data-recollection': dataRecollection,
    'custom-progress': customProgress
  },

  // router params 対応
  props: ["isActiveLabel"],

  methods: {
    ...mapActions('auth', ['logout']),
    ...mapActions('cache', ['cacheDiagProjectList', 'cacheProjectDetails']),
    ...mapActions('fileResources', ['checkSBRUser']),

    /** 計測データセットアップ */
    setupMeasuredData: async function () {
      try {
        let resDiagDtc;
        let resVch;
        let resCst;
        let resCnc;
        let resWsp;
        let resDmAt;
        let resObd;
        let failedFlg = false;
        if (this.initApiFlg) {
          this.processing = true;
          // 機能に合わせてカラムの更新を行う
          this.updateColumns();
          // 各種API実行
          const projectIdMeasureEndPoint = this.projectDetails.id + '/measures';

          const gettingMeasuredDataMethods = [
            this.getMeasureData(service.DIAG, PROJECTS + projectIdMeasureEndPoint),
            this.getMeasureData(service.VCH, PROJECTS + projectIdMeasureEndPoint),
            this.getMeasureData(service.CST, PROJECTS + projectIdMeasureEndPoint),
            this.getMeasureData(service.CNC, PROJECTS + projectIdMeasureEndPoint),
            this.getMeasureData(service.WSP, PROJECTS + projectIdMeasureEndPoint),
            this.getMeasureData(service.OBD, PROJECTS + projectIdMeasureEndPoint, this.operationScreen),
            this.getMeasureData(service.DMAT, PROJECTS + projectIdMeasureEndPoint, this.operationScreen),
          ];
          // イベントログ一覧取得(SBRユーザーのみ実行）
          if (this.isSBRUser) {
            gettingMeasuredDataMethods.push(this.processingEventLog());
          }

          // 各機能のプロジェクトデータを非同期で取得
          await Promise.allSettled(gettingMeasuredDataMethods).then((results) => {
            resDiagDtc = results[0].value;
            resVch = results[1].value;
            resCst = results[2].value;
            resCnc = results[3].value;
            resWsp = results[4].value;
            resObd = results[5].value;
            resDmAt = results[6].value;
          });

          // プロジェクトデータの取得に１機能でも取得に失敗した場合、エラーダイアログを表示するためのフラグを立てる
          if (!resDiagDtc || !resVch || !resCst || !resCnc || !resWsp || !resDmAt || !resObd || resObd.data.error_occurred) {
            failedFlg = true;
          }

          // アプライドモデル設定
          await this.getAppliedModel(service.DIAG, PROJECTS, resDiagDtc.data.measures);

          // 各計測データを保持用のデータに格納
          this.reproDetailsData = this.setMeasuresData(service.DIAG, resDiagDtc.data.measures);
          this.allDtcMeasuresData = this.reproDetailsData.filter(d => { return d.function_name === 'alldtc'; });
          this.diagCodeMeasuresData = this.reproDetailsData.filter(d => { return d.function_name === 'individualDtc'; });
          this.readinessMeasuresData = this.reproDetailsData.filter(d => { return d.function_name === 'readinessCode'; });
          this.cstMeasuresData = this.setMeasuresData(service.CST, resCst.data.measures);
          this.indCstMeasuresData = this.cstMeasuresData.filter(d => { return d.function_name === 'cst'; });
          this.allCstMeasuresData = this.cstMeasuresData.filter(d => { return d.function_name === 'all_cst'; });
          this.vchMeasuresData = this.setMeasuresData(service.VCH, resVch.data.measures, 'controlHistory');
          this.cncMeasuresData = this.setMeasuresData(service.CNC, resCnc.data.measures, 'cancelCode');
          this.wspMeasuresData = this.setMeasuresData(service.WSP, resWsp.data.measures, 'workSupport');
          this.dmatDetailsData = this.setMeasuresData(service.DMAT, resDmAt.data.measures);
          this.indDmMeasuresData = this.dmatDetailsData.filter(d => { return d.function_name === 'dm'; });
          this.atMeasuresData = this.dmatDetailsData.filter(d => { return d.function_name === 'at'; });
          this.mltDmMeasuresData = this.dmatDetailsData.filter(d => { return d.function_name === 'multiple_dm'; });
          this.obdDetailsData = this.setMeasuresData(service.OBD, resObd.data.measures);
          this.obdAllDtcMeasuresData = this.obdDetailsData.filter(d => { return d.function_name === 'all_dtc'; });
          this.obdOnBoardMonitorTestMeasuresData = this.obdDetailsData.filter(d => { return d.function_name === 'onboard_monitor_test'; });
          this.obdDataMonitorMeasuresData = this.obdDetailsData.filter(d => { return d.function_name === 'data_monitor'; });
          this.obdDiagCodeMeasuresData = this.obdDetailsData.filter(d => { return d.function_name === 'individual_dtc'; });
          this.obdPermanentDiagCodeMeasuresData = this.obdDetailsData.filter(d => { return d.function_name === 'p_dtc'; });
          this.obdVehicleInfoMeasuresData = this.obdDetailsData.filter(d => { return d.function_name === 'obd_vehicle_info'; });
          this.obdIumprMeasuresData = this.obdDetailsData.filter(d => { return d.function_name === 'individual_iumpr'; });
          this.obdReadinessStatusMeasuresData = this.obdDetailsData.filter(d => { return d.function_name === 'individual_readiness'; });
        }
        this.checkFunctionKey('details');

        if (failedFlg) {
          alert.showError(this, null, this.$t("fixed_resource.failed_get_measures_list")); // OK 押下後は何もしない（取得できた範囲で表示する
        }
      } finally {
        this.processing = false;
        this.initApiFlg = false;
      }
    },

    /**
     * ログインしている環境と異なる環境（マスター/ミラー）の計測データを選択した場合の計測データセットアップ
     * 全DTC・レディネスコード・データモニタ・マルチデータモニタ・アクティブテストのデータのみを表示する
     */
    setupReadOnlyMeasuredData: async function () {
      try {
        let resDiagDtc;
        let resDmAt;
        let failedFlg = false;
        if (this.initApiFlg) {
          this.processing = true;
          // 機能に合わせてカラムの更新を行う
          this.updateColumns();
          // 各種API実行
          const projectIdMeasureEndPoint = this.projectDetails.id + '/measures';

          const gettingMeasuredDataMethods = [
            this.getMeasureData(service.DIAG, PROJECTS + projectIdMeasureEndPoint),
            this.getMeasureData(service.DMAT, PROJECTS + projectIdMeasureEndPoint, this.operationScreen),
          ];

          // 各機能のプロジェクトデータを非同期で取得
          await Promise.allSettled(gettingMeasuredDataMethods).then((results) => {
            resDiagDtc = results[0].value;
            resDmAt = results[1].value;
          });

          // プロジェクトデータの取得に１機能でも取得に失敗した場合、エラーダイアログを表示するためのフラグを立てる
          if (!resDiagDtc || !resDmAt) {
            failedFlg = true;
          }

          // アプライドモデル設定
          await this.getAppliedModel(service.DIAG, PROJECTS, resDiagDtc.data.measures);

          // 各計測データを保持用のデータに格納
          this.reproDetailsData = this.setMeasuresData(service.DIAG, resDiagDtc.data.measures);
          this.allDtcMeasuresData = this.reproDetailsData.filter(d => { return d.function_name === 'alldtc'; });
          this.readinessMeasuresData = this.reproDetailsData.filter(d => { return d.function_name === 'readinessCode'; });
          this.dmatDetailsData = this.setMeasuresData(service.DMAT, resDmAt.data.measures);
          this.indDmMeasuresData = this.dmatDetailsData.filter(d => { return d.function_name === 'dm'; });
          this.atMeasuresData = this.dmatDetailsData.filter(d => { return d.function_name === 'at'; });
          this.mltDmMeasuresData = this.dmatDetailsData.filter(d => { return d.function_name === 'multiple_dm'; });
        }
        this.checkFunctionKey('details');

        if (failedFlg) {
          alert.showError(this, null, this.$t("fixed_resource.failed_get_measures_list")); // OK 押下後は何もしない（取得できた範囲で表示する
        }
      } finally {
        this.processing = false;
        this.initApiFlg = false;
      }
    },

    /**
     * 機能および計測データ格納かメモ編集対象機能を判断
     * @param {String} switchKey 判定キー
     * @returns service
     */
    checkFunctionKey(switchKey) {
      const functionKey = this.currentFunctionKey;

      let service = '';
      // 判定キーで処理分岐
      if (switchKey === 'details') this.setDetailsDataTable(functionKey);
      if (switchKey === 'service') service = this.functionUpdateDetect(functionKey);
      return service;
    },

    /**
     * 初期表示・タブを押下した機能の計測データを格納
     * @param {String} functionKey 機能キー
     */
    setDetailsDataTable(functionKey) {
      switch (functionKey) {
        case 'allDtc':
          this.detailsDataTable = this.allDtcMeasuresData;
          break;
        case 'diagCode':
          this.detailsDataTable = this.diagCodeMeasuresData;
          break;
        case 'readiness':
          this.detailsDataTable = this.readinessMeasuresData;
          break;
        case 'controlHistory':
          this.detailsDataTable = this.vchMeasuresData;
          break;
        case 'customize':
          this.detailsDataTable = this.indCstMeasuresData;
          break;
        case 'cancelCode':
          this.detailsDataTable = this.cncMeasuresData;
          break;
        case 'workSupport':
          this.detailsDataTable = this.wspMeasuresData;
          break;
        case 'dataMonitor':
          this.detailsDataTable = this.indDmMeasuresData;
          break;
        case 'activeTest':
          this.detailsDataTable = this.atMeasuresData;
          break;
        case 'obdAllDtc':
          this.detailsDataTable = this.obdAllDtcMeasuresData;
          break;
        case 'obdDiagCode':
          this.detailsDataTable = this.obdDiagCodeMeasuresData;
          break;
        case 'obdPermanentDiagCode':
          this.detailsDataTable = this.obdPermanentDiagCodeMeasuresData;
          break;
        case 'obdVehicleInfo':
          this.detailsDataTable = this.obdVehicleInfoMeasuresData;
          break;
        case 'obdOnBoardMonitorTest':
          this.detailsDataTable = this.obdOnBoardMonitorTestMeasuresData;
          break;
        case 'obdDataMonitor':
          this.detailsDataTable = this.obdDataMonitorMeasuresData;
          break;
        case 'multipleDataMonitor':
          this.detailsDataTable = this.mltDmMeasuresData;
          break;
        case 'allCustomize':
          this.detailsDataTable = this.allCstMeasuresData;
          break;
        case 'obdIumpr':
          this.detailsDataTable = this.obdIumprMeasuresData;
          break;
        case 'obdReadinessStatus':
          this.detailsDataTable = this.obdReadinessStatusMeasuresData;
          break;
      }
    },

    /**
     * 計測データ取得処理
     * @param {String} serviceName サービス
     * @param {String} endpoint APIエンドポイント
     * @param {String} operationScreen 操作画面キー名
     * @returns  レスポンスデータ
     */
    async getMeasureData(serviceName, endpoint, operationScreen = undefined) {
      const params = { region_info: this.cachedProjectDataSource };
      let res = '';

      if (!operationScreen) {
        res = await api.getParamCall(serviceName, endpoint, params);
      } else {
        res = await api.getParamCall(serviceName, endpoint, params, operationScreen);
      }
      await this.checkValidate(res);
      return res;
    },

    /**
    * Backendレスポンス値のチェック処理
    * @param {Object} res レスポンス
    * @returns 200ならtrue、左記以外だったらログアウト
    */
    async checkValidate(res) {
      await handler.validate(handler.validateTypes.all, res, this, null, () => {
      }, (result) => {
        if (result.behaviorType === handler.behaviorTypes.logout) this.logout(this);
      });
    },

    /**
     * Backendレスポンス値のチェック処理
     * @param {Object} res レスポンス
     * @returns 正常の場合：true
     *          異常の場合：false、条件分岐でログアウト処理
     */
    async isResponseDataCheck(res) {
      handler.validate(handler.validateTypes.all, res, this, null, () => {
        return true;
      }, (result) => {
        if (result.behaviorType === handler.behaviorTypes.logout) this.logout(this);
        return false;
      });
    },

    /**
     * アプライドモデル取得処理
     * @param {String} service サービス
     * @param {String} funcPoint API機能名
     * @param {Array} measured 計測データ
     */
    async getAppliedModel(service, funcPoint, measured) {
      if (measured && measured.length > 0) {
        const endpoint = funcPoint + this.projectDetails.id + '/' + measured[0].registered_at;
        // アプライドモデルをプロジェクト詳細から取得
        const detailRes = await this.getMeasureData(service, endpoint, this.operationScreen);
        // レスポンスチェック
        handler.validate(handler.validateTypes.all, detailRes, this, null, () => {
          this.projectDetails.applied_model = detailRes.data.project.vin.applied_model || '';
          // vinタイプの取得
          this.vinType = detailRes.data.project.vin.type || '';
        }, (result) => {
          if (result.behaviorType === handler.behaviorTypes.logout) this.logout(this);
        });
      } else {
        this.projectDetails.applied_model = '';
      }
    },

    /**
     * 計測データテーブル設定処理
     * @param {string} serviceType Backend サービス
     * @param {Array<object>} measured レスポンスの計測データ
     * @param {string} functionKey 機能名に表示するキー
     * @returns テーブル表示用データ配列
     */
    // eslint-disable-next-line complexity
    setMeasuresData(serviceType, measured, functionKey = undefined) {
      const tmp = [];

      for (const m of measured || []) {
        let tmpSystem = '';
        let tmpSystemStr = '';
        let tmpItemName = '';
        let tmpObdSystems = [];

        if (serviceType === service.OBD) {
          tmpObdSystems = (m.obd_systems || []).map((obdSystem) => {
            if (!tmpSystem && this.chkObdIndividualFuncName(m.function_name)) {
              // OBD の個別診断機能はシステム名称を診断実行時に ECU から読み出した値をそのまま設定する
              // 翻訳しない点に注意
              tmpSystem = obdSystem.system_name;
            }

            return {
              systemName: obdSystem.system_name,
              systemNo: obdSystem.system_no,
              diagnosticSystemId: obdSystem.diagnostic_system_id,
            };
          });
        } else if (m.systems) {
          // 全DTC、DTC、レディネスコードにおいて、レスポンスの値がsystemsなのでsystemsでチェック
          if (m.systems.length === 1) {
            tmpSystem = 'diagSytem.' + m.systems[0];
            // システムの表示名を判定
            if (m.function_name === 'individualDtc') {
              // DTCの時はシステム名を翻訳し、特殊機能なら特殊機能を表す値を付加する
              tmpSystemStr = getSystemNameIsSpecial(this, m.function_name, m.systems[0], m.is_special);
            }
          }
        } else if (m.system) {                // 全DTC、DTC、レディネスコード以外はすべてsystemになる
          if (m.function_name === 'multiple_dm') {
            // マルチデータモニタはシステム名を翻訳し'/'で連結
            tmpSystem = m.system.map(id => {
              return `${this.$t('diagSytem.' + id)} (${dmUtil.getAbbrSysName(id)})`;
            }).join('/');
          } else if (m.function_name === 'all_cst') {
            tmpSystem = 'message.label_menu_all_system';
          } else {
            // systemが配列の場合、配列の0番目を参照
            const systemName = Array.isArray(m.system) ? m.system[0] : m.system;

            let funcName;
            switch (m.function_name) {
              case 'dm':
                funcName = 'dataMonitor';
                break;
              case 'at':
                funcName = 'activeTest';
                break;
              default:
                funcName = functionKey;
                break;
            }

            tmpSystem = tmpSystem = 'diagSytem.' + systemName;
            tmpSystemStr = getSystemNameIsSpecial(this, funcName, systemName, m.is_special);
          }
        }
        if (functionKey === 'workSupport') {  // 作業サポートは機能名も表示する
          tmpItemName = this.getItemName(m);
        }
        if (m.function_name === 'at') {  // アクティブテストは機能名も表示する
          tmpItemName = this.getItemNameAt(m);
        }

        tmp.push({
          system: tmpSystem,
          systemIds: m.system,
          displaySystemName: tmpSystemStr,
          item_name: tmpItemName ? tmpItemName : undefined,
          name: m.data_name,
          registered_at: m.registered_at,
          updated_at: util.timeConverter(m.last_update_time),
          note: m.memo,
          buttonVisible: true,
          function_name: functionKey ? functionKey : m.function_name,
          measurement_id: m.measurement_id,
          monitor_items: m.monitor_items,
          special_requirement_id: m.special_requirement_id ? m.special_requirement_id : undefined,
          region: m.region,
          obdDataId: m.obd_data_id || undefined,
          obdSystems: tmpObdSystems,
          measure_id: m.measure_id || undefined,
          session_id: m.session_id || undefined,
          at_info: m.at_info || [],
          at_operating_status_list: m.at_operating_status_list || [],
          isSpecial: m.is_special || undefined,
          storage: m.storage || undefined
        });
      }
      return util.sortItems(tmp, 'registered_at');
    },

    /**
     * 作業サポート機能名取得
     * @param {Object} measuredData 
     * @returns 作業サポート機能名
     */
    getItemName(measuredData) {
      // WS.96の場合
      if (measuredData.immutable_id === 9601) {
        // control_history_type で判定
        if (measuredData.control_history_type) {
          switch (measuredData.control_history_type) {
            case 'lks': // LKS作動履歴
              return `ws${measuredData.system}.${measuredData.immutable_id}.lks_button`;
            case 'aeb': // LKS作動履歴(AEB作動/衝突検知時)
              return `ws${measuredData.system}.${measuredData.immutable_id}.lks_aeb_button`;
            case 'wall_avoid': // 車線逸脱抑制(構造物)作動履歴
              return `ws${measuredData.system}.${measuredData.immutable_id}.road_structures_button`;
            default:
              break;
          }
        }
        // is_aeb で判定 (is_aeb ⇒ control_history_type に作動履歴区分を変更したが、is_aebで生成済の計測データが存在するため、is_aeb判定を残す)
        if (measuredData.is_aeb) {
          // LKS作動履歴(AEB作動/衝突検知時)
          return `ws${measuredData.system}.${measuredData.immutable_id}.lks_aeb_button`;
        } else {
          // LKS作動履歴
          return `ws${measuredData.system}.${measuredData.immutable_id}.lks_button`;
        }
      } else if (measuredData.special_requirement_id === 'ES9') {
        // ES9の場合
        // control_history_type で判定
        if (measuredData.control_history_type === 'wall_avoid') {
          // 車線逸脱抑制(構造物)作動履歴
          return `spws${measuredData.system}.${measuredData.immutable_id}.label_road_structures_special_feature`;
        }
      }
      // 上記以外の場合
      return `ws${measuredData.system}.${measuredData.immutable_id}.menu_title`;
    },

    /**
     * アクティブテスト機能名取得
     * @param {Object} measuredData 計測情報
     * @returns アクティブテスト機能名の翻訳キー
     */
    getItemNameAt(measuredData) {
      return atUtil.getAtFunctionTranslateKey(this, measuredData.active_test_id, measuredData.system);
    },

    /**
     * 機能名がOBD個別診断機能対象かの判定
     * @param {*} funcName 機能名
     * @returns 判定結果（true:OBD個別診断機能該当/false:OBD個別診断機能未該当）
     */
    chkObdIndividualFuncName(funcName) {
      if (funcName === 'individual_dtc' || funcName === 'data_monitor' || funcName === 'onboard_monitor_test' || funcName === 'obd_vehicle_info'
        || funcName === 'p_dtc' || funcName === 'individual_readiness' || funcName === 'individual_iumpr') {
        return true;
      }
      return false;
    },

    /** 診断コメントモーダル表示 */
    openUpdateConfirmModal: async function () {
      // 入力検証
      if (!this.commentValidate()) return;
      const msg = this.$t('message.message_measured_data_details_update_comment');
      alert.showConfirmation(this, null, msg, async () => {
        this.processing = true;
        const res = await api.postCall(config.DIAG, '/projects/' + this.projectDetails.id, {
          name: this.projectDetails.name,
          comment: this.projectDetails.comment,
          region_info: this.cachedProjectDataSource
        });
        this.processing = false;
        handler.validate(handler.validateTypes.all, res, this, null, () => {
          // プロジェクト一覧のキャッシュ内のコメントを更新
          const list = this.cachedProjects.list.map(p => {
            const comment = p.id === this.projectDetails.id ? this.projectDetails.comment : p.comment;
            return { ...p, comment };
          });
          this.cacheDiagProjectList({ ...this.cachedProjects, list });
          // プロジェクト詳細をキャッシュ
          this.originalComment = this.projectDetails.comment;
          this.cacheProjectDetails({ information: this.projectDetails });
        }, (result) => {
          if (result.behaviorType === handler.behaviorTypes.logout) this.logout(this);
        });
      });
    },

    /**
     * メモ編集画面開く処理
     * @param {Object} arg 選択行
     */
    openEditNoteModal: function (arg) {
      this.clearAlert();
      this.selectedData = arg;
      this.selectedUpdatedTime = util.timeConverter(arg.updated_at);
      this.filledDataName = arg.name;
      this.filledDataNote = arg.note;
      this.modalEdit = true;
    },

    /** メモ編集画面更新ボタン */
    updateNote: async function () {
      try {
        // 入力検証
        if (!this.validate()) return;
        this.modalLoading = true;
        const endpoint = '/projects/' + this.projectDetails.id + '/' + this.selectedData.registered_at;
        const service = await this.checkFunctionKey('service');
        let res = null;
        res = await api.postCall(service, endpoint, { measured: { name: this.filledDataName, memo: this.filledDataNote }, region_info: this.cachedProjectDataSource }, this.operationScreen);
        handler.validate(handler.validateTypes.all, res, this, null, () => {
          this.updateListData(this.selectedData.registered_at);
          this.modalEdit = false;
        }, (result) => {
          if (result.behaviorType === handler.behaviorTypes.logout) this.logout(this);
        });
      } finally {
        this.modalLoading = false;
      }
    },

    /**
     * メモ編集画面の更新ボタン押下時にデータ名、メモが更新される
     * @param {Integer} measuresId 計測データID
     */
    updateListData(measuresId) {
      this.detailsDataTable.map(d => {
        if (d.registered_at === measuresId) {
          d.name = this.filledDataName;
          d.note = this.filledDataNote;
        }
      });
    },

    /**
     * 編集内容をアップデートするテーブルを判定
     * @param {String} functionKey 機能キー
     * @returns 対象サービス
     */
    functionUpdateDetect(functionKey) {
      let serviceKey = '';
      switch (functionKey) {
        case 'allDtc':
        case 'diagCode':
        case 'readiness':
          serviceKey = config.DIAG;
          break;
        case 'controlHistory':
          serviceKey = config.VCH;
          break;
        case 'customize':
        case 'allCustomize':
          serviceKey = config.CST;
          break;
        case 'cancelCode':
          serviceKey = config.CNC;
          break;
        case 'workSupport':
          serviceKey = config.WSP;
          break;
        case 'dataMonitor':
        case 'activeTest':
        case 'multipleDataMonitor':
          serviceKey = config.DMAT;
          break;
        case 'obdAllDtc':
        case 'obdDiagCode':
        case 'obdPermanentDiagCode':
        case 'obdVehicleInfo':
        case 'obdOnBoardMonitorTest':
        case 'obdDataMonitor':
        case 'obdIumpr':
        case 'obdReadinessStatus':
          serviceKey = service.OBD;
          break;
      }
      return serviceKey;
    },

    /**
     * バリデーションチェック
     * @returns boolean
     */
    validate() {
      // 検証結果キャッシュの初期化
      this.clearAlert();
      const resultPool = [];

      // データ名の必須チェック
      this.isAlert.filledDataName = exam.excuteValidateCommons(this.filledDataName, true, 0, config.MEMOINFO_DETA_NAME_MAX_LEN);
      resultPool.push(this.isAlert.filledDataName.valid);

      // メモの文字数チェック
      this.isAlert.filledDataNote = exam.excuteValidateCommons(this.filledDataNote, false, 0, config.MEMOINFO_MAX_LEN);
      resultPool.push(this.isAlert.filledDataNote.valid);

      const faults = resultPool.filter(el => el === false);
      return faults.length === 0;
    },

    /**
     * 診断コメントバリデーションチェック
     * @returns boolean
     */
    commentValidate() {
      // 検証結果キャッシュの初期化
      this.clearAlert();
      const resultPool = [];

      // 診断コメントのチェック
      this.isAlert.comment = exam.excuteValidateCommons(this.projectDetails.comment, false, 0, config.MEMOINFO_MAX_LEN);
      resultPool.push(this.isAlert.comment.valid);

      const faults = resultPool.filter(el => el === false);
      return faults.length === 0;
    },

    // 入力検証アラートのクリア
    clearAlert: function () {
      this.isAlert = {
        filledDataName: { valid: null, msg: '' },
        filledDataNote: { valid: null, msg: '' },
        comment: { valid: null, msg: '' },
      };
    },

    /**
     * 計測データ再生画面に遷移処理
     * @param {Object} row 選択行
     */
    goToDataRecollection: function (row) {
      // コメントの変更内容を確定しないままデータ再生画面に遷移したときに
      // 未確定のコメント内容もキャッシュしてしまうことを防止する
      this.projectDetails.comment = this.originalComment;
      // vinタイプを追加
      this.projectDetails.vinType = this.vinType;
      const allMeasuresData = [{
        repro: this.reproDetailsData, vch: this.vchMeasuresData, cst: this.cstMeasuresData, cnc: this.cncMeasuresData,
        wsp: this.wspMeasuresData, dmat: this.dmatDetailsData, obd: this.obdDetailsData
      }];
      this.cacheProjectDetails({ information: this.projectDetails, measures: allMeasuresData });

      this.$router.push({
        name: "dataRecollection",
        params: {
          /**
           * 単位設定からデータ再生に戻る際、このparamsとデータ再生画面で
           * キャッシュしたデータを組み合わせてデータ再生画面の再描画を行います。
           * paramsに計測データ固有の値を追加する場合は、データ再生画面のbeforeUnmountで値をキャッシュし、
           * beforeMountでキャッシュから値を取り出してください。
           */
          allMeasuresData: JSON.stringify(allMeasuresData),
          measuredIdProp: row.registered_at,
          isActiveLabel: JSON.stringify(this.activeLabel),
          systemName: row.system,
          systemIds: row.systemIds,
          itemNameProp: row.item_name,
          obdDataIdProp: row.obdDataId,
          obdSystemsProp: JSON.stringify(row.obdSystems),
          isOnlyCsvExport: false
        },
      });
    },

    /** プロジェクト一覧に遷移 */
    backToProjectList: function () {
      this.$router.push({ name: 'diagProjectList' });
    },

    /**
     * タブを押下した機能を判定
     * @param {String} id  機能キー
     */
    functionDetectSwitch(id) {
      this.setNavTabLabel();
      for (const keys in this.activeLabel) {
        if (id === keys) {
          this.activeLabel[keys] = true;
        } else {
          this.activeLabel[keys] = false;
        }
      }
      this.updateColumns();
      this.checkFunctionKey('details');
    },

    /** カラムのデータ更新処理 */
    updateColumns() {
      if (this.activeLabel.allDtc || this.activeLabel.obdAllDtc) {
        this.detailsColumns = [
          { name: 'name', label: 'message.label_measured_data_details_data_name' },
          { name: 'updated_at', label: 'message.label_measured_data_details_update_time' },
          { name: 'note', label: 'message.label_measured_data_details_notes' },
          { name: 'edit', label: 'message.label_measured_data_details_edit', useButton: true }
        ];
      } else if (this.activeLabel.workSupport) {
        this.detailsColumns = [
          { name: 'system', label: 'message.header_vehicle_table_system_name', useResource: true },
          { name: 'item_name', label: 'individual.header_work_support_table_item', useResource: true },
          { name: 'name', label: 'message.label_measured_data_details_data_name' },
          { name: 'updated_at', label: 'message.label_measured_data_details_update_time' },
          { name: 'note', label: 'message.label_measured_data_details_notes' },
          { name: 'edit', label: 'message.label_measured_data_details_edit', useButton: true }
        ];
      } else if (this.activeLabel.activeTest) {
        this.detailsColumns = [
          { name: 'displaySystemName', label: 'message.header_vehicle_table_system_name', useResource: true },
          { name: 'item_name', label: 'individual.header_active_test_table_item', useResource: true },
          { name: 'name', label: 'message.label_measured_data_details_data_name' },
          { name: 'updated_at', label: 'message.label_measured_data_details_update_time' },
          { name: 'note', label: 'message.label_measured_data_details_notes' },
          { name: 'export', label: 'message.button_home_download_cc', useSecondButton: true },
          { name: 'edit', label: 'message.label_measured_data_details_edit', useButton: true }
        ];
      } else if (this.activeLabel.multipleDataMonitor) {
        this.detailsColumns = [
          { name: 'system', label: 'message.header_vehicle_table_system_name', useResource: false },
          { name: 'name', label: 'message.label_measured_data_details_data_name' },
          { name: 'updated_at', label: 'message.label_measured_data_details_update_time' },
          { name: 'note', label: 'message.label_measured_data_details_notes' },
          { name: 'export', label: 'message.button_home_download_cc', useSecondButton: true },
          { name: 'edit', label: 'message.label_measured_data_details_edit', useButton: true }
        ];
      } else if (this.activeLabel.dataMonitor) {
        this.detailsColumns = [
          { name: 'displaySystemName', label: 'message.header_vehicle_table_system_name', useResource: false },
          { name: 'name', label: 'message.label_measured_data_details_data_name' },
          { name: 'updated_at', label: 'message.label_measured_data_details_update_time' },
          { name: 'note', label: 'message.label_measured_data_details_notes' },
          { name: 'export', label: 'message.button_home_download_cc', useSecondButton: true },
          { name: 'edit', label: 'message.label_measured_data_details_edit', useButton: true }
        ];
      } else if (this.activeLabel.obdDataMonitor) {
        const useResource = FUNCTION_CONFIGS[this.currentFunctionKey]?.useResourceSystemName;
        this.detailsColumns = [
          { name: 'system', label: 'message.header_vehicle_table_system_name', useResource: !!useResource },
          { name: 'name', label: 'message.label_measured_data_details_data_name' },
          { name: 'updated_at', label: 'message.label_measured_data_details_update_time' },
          { name: 'note', label: 'message.label_measured_data_details_notes' },
          { name: 'export', label: 'message.button_home_download_cc', useSecondButton: true },
          { name: 'edit', label: 'message.label_measured_data_details_edit', useButton: true },
        ];
      } else if (this.activeLabel.cancelCode || this.activeLabel.controlHistory || this.activeLabel.diagCode) {
        this.detailsColumns = [
          { name: 'displaySystemName', label: 'message.header_vehicle_table_system_name' },
          { name: 'name', label: 'message.label_measured_data_details_data_name' },
          { name: 'updated_at', label: 'message.label_measured_data_details_update_time' },
          { name: 'note', label: 'message.label_measured_data_details_notes' },
          { name: 'edit', label: 'message.label_measured_data_details_edit', useButton: true }
        ];
      } else {
        const useResource = FUNCTION_CONFIGS[this.currentFunctionKey]?.useResourceSystemName;
        this.detailsColumns = [
          { name: 'system', label: 'message.header_vehicle_table_system_name', useResource: !!useResource },
          { name: 'name', label: 'message.label_measured_data_details_data_name' },
          { name: 'updated_at', label: 'message.label_measured_data_details_update_time' },
          { name: 'note', label: 'message.label_measured_data_details_notes' },
          { name: 'edit', label: 'message.label_measured_data_details_edit', useButton: true }
        ];
      }
    },

    /** ナビゲーションタブの表示文言を設定する */
    setNavTabLabel() {
      this.displayTabLabelList = Object.keys(this.activeLabel).map((key) =>
        createTabName(this, key)
      );
    },

    /**
     * キャッシュがある場合データ取得を行う
     * 取得するデータは各一覧取得APIと同等のデータ
     * @param {Array} tmpMeasures キャッシュデータ
     */
    async changeDetailData(tmpMeasures) {
      // キャッシュからデータ取得(ALL DTC、DTC、レディネスコード)
      this.reproDetailsData = tmpMeasures.repro;
      this.dmatDetailsData = tmpMeasures.dmat;
      this.obdDetailsData = tmpMeasures.obd;
      this.cstMeasuresData = tmpMeasures.cst;
      let activeLabelObj = {};
      // 計測データ再生画面から遷移した場合か初期表示なのか判定で使用するデータを分ける
      if (this.isActiveLabel) {
        activeLabelObj = JSON.parse(this.isActiveLabel);
      } else {
        activeLabelObj = this.activeLabel;
      }

      // キーに一致したデータを表示
      /* eslint-disable complexity */
      Object.keys(activeLabelObj).forEach(key => {
        if (key === 'allDtc') this.allDtcMeasuresData = util.sortItems(tmpMeasures.repro.filter(d => { return d.function_name === 'alldtc'; }));
        if (key === 'diagCode') {
          this.diagCodeMeasuresData = util.sortItems(tmpMeasures.repro.filter(d => { return d.function_name === 'individualDtc'; }));
          setMeasuresDisplaySystemName(this, key, this.diagCodeMeasuresData, [], [], [], []);
        }
        if (key === 'readiness') this.readinessMeasuresData = util.sortItems(tmpMeasures.repro.filter(d => { return d.function_name === 'readinessCode'; }));
        if (key === 'controlHistory') {
          this.vchMeasuresData = tmpMeasures.vch;
          setMeasuresDisplaySystemName(this, key, [], this.vchMeasuresData, [], [], []);
        }
        if (key === 'customize') this.indCstMeasuresData = util.sortItems(tmpMeasures.cst.filter(d => { return d.function_name === 'cst'; }));
        if (key === 'allCustomize') this.allCstMeasuresData = util.sortItems(tmpMeasures.cst.filter(d => { return d.function_name === 'all_cst'; }));
        if (key === 'cancelCode') {
          this.cncMeasuresData = tmpMeasures.cnc;
          setMeasuresDisplaySystemName(this, key, [], [], this.cncMeasuresData, [], []);
        }
        if (key === 'workSupport') this.wspMeasuresData = tmpMeasures.wsp;
        if (key === 'dataMonitor') {
          this.indDmMeasuresData = util.sortItems(tmpMeasures.dmat.filter(d => { return d.function_name === 'dm'; }));
          setMeasuresDisplaySystemName(this, key, [], [], [], this.indDmMeasuresData, []);
        }
        if (key === 'activeTest') {
          this.atMeasuresData = util.sortItems(tmpMeasures.dmat.filter(d => { return d.function_name === 'at'; }));
          setMeasuresDisplaySystemName(this, key, [], [], [], [], this.atMeasuresData);
        }
        if (key === 'obdAllDtc') this.obdAllDtcMeasuresData = util.sortItems(tmpMeasures.obd.filter(d => { return d.function_name === 'all_dtc'; }));
        if (key === 'obdDiagCode') this.obdDiagCodeMeasuresData = util.sortItems(tmpMeasures.obd.filter(d => { return d.function_name === 'individual_dtc'; }));
        if (key === 'obdDataMonitor') this.obdDataMonitorMeasuresData = util.sortItems(tmpMeasures.obd.filter(d => { return d.function_name === 'data_monitor'; }));
        if (key === 'obdOnBoardMonitorTest') this.obdOnBoardMonitorTestMeasuresData = util.sortItems(tmpMeasures.obd.filter(d => { return d.function_name === 'onboard_monitor_test'; }));
        if (key === 'obdVehicleInfo') this.obdVehicleInfoMeasuresData = util.sortItems(tmpMeasures.obd.filter(d => { return d.function_name === 'obd_vehicle_info'; }));
        if (key === 'obdPermanentDiagCode') this.obdPermanentDiagCodeMeasuresData = util.sortItems(tmpMeasures.obd.filter(d => { return d.function_name === 'p_dtc'; }));
        if (key === 'multipleDataMonitor') this.mltDmMeasuresData = util.sortItems(tmpMeasures.dmat.filter(d => { return d.function_name === 'multiple_dm'; }));
        if (key === 'obdIumpr') this.obdIumprMeasuresData = util.sortItems(tmpMeasures.obd.filter(d => { return d.function_name === 'individual_iumpr'; }));
        if (key === 'obdReadinessStatus') this.obdReadinessStatusMeasuresData = util.sortItems(tmpMeasures.obd.filter(d => { return d.function_name === 'individual_readiness'; }));
      });
      // データ再生画面から保存データに切り替え時に翻訳処理
      this.getMultipleDMSystemName();
      this.updateColumns();
      this.checkFunctionKey('details');
    },

    /** ジョブID発行処理 */
    async createJobId() {
      const projectsId = this.projectDetails.id;
      const endPoint = `/projects/${projectsId}/listEventLogs/jobs`;
      const body = {
        // リージョン情報をサーバーに通知（マスター/ミラー環境の識別）
        region_info: this.cachedProjectDataSource
      };

      const jobConfigs = [
        // 車両通信データ ジョブID生成
        { serviceName: config.DIAG, idKey: 'rprJobId', operationScreen: this.operationScreen },
        // IMBジョブID生成
        { serviceName: config.IMB, idKey: 'imbJobId' },
        // MAC鍵ジョブID生成
        { serviceName: config.MAC, idKey: 'macJobId' }
      ];

      for (const { serviceName, idKey, operationScreen } of jobConfigs) {
        const response = operationScreen
          ? await api.postCall(serviceName, endPoint, body, operationScreen)
          : await api.postCall(serviceName, endPoint, body);

        if (this.isResponseDataCheck(response)) {
          this[idKey] = response.data.id;
        } else {
          return false;
        }
      }

      return true;
    },

    /** ポーリング(非同期処理) と一覧取得API実行*/
    async pollingProcess() {
      let operationScreen = null;
      const projectsId = this.projectDetails.id;
      // polling処理共通部分抜き出し
      const somePartApi = `/projects/${projectsId}/listEventLogs/jobs/`;
      // リプロポーリング処理
      if (this.rprJobId) {
        operationScreen = this.operationScreen;
        const rprEventLogListResponse = await this.getPollingEventLog(config.DIAG, projectsId, this.rprJobId, operationScreen);
        // レスポンスがnullの場合は、ブラウザバックにて処理を中断しているので、APIがこれ以上継続しないためにreturnさせる
        if (rprEventLogListResponse === null) {
          return;
        }
        if (this.isResponseDataCheck(rprEventLogListResponse)) {
          this.rprEventLogListResult = await this.getCallApi(config.DIAG, `${somePartApi}${this.rprJobId}/results?region_info=${this.cachedProjectDataSource}`, operationScreen);
          // レスポンスがnullの場合は、ブラウザバックにて処理を中断しているので、APIがこれ以上継続しないためにreturnさせる
          if (this.rprEventLogListResult === null) {
            return;
          }
          if (this.isResponseDataCheck(this.rprEventLogListResult)) {
            this.createEventLogItemsRpr();
            this.eventLogItems = this.eventLogItems.concat(this.rprEventLogListResult.data.event_logs);
            // 初期化
            operationScreen = null;
          }
        }
      }

      // イモビライザポーリング処理
      if (this.imbJobId) {
        const imbEventLogListResponse = await this.getPollingEventLog(config.IMB, projectsId, this.imbJobId, operationScreen);
        // レスポンスがnullの場合は、ブラウザバックにて処理を中断しているので、APIがこれ以上継続しないためにreturnさせる
        if (imbEventLogListResponse === null) {
          return;
        }
        if (this.isResponseDataCheck(imbEventLogListResponse)) {
          this.imbEventLogListResult = await this.getCallApi(config.IMB, `${somePartApi}${this.imbJobId}/results?region_info=${this.cachedProjectDataSource}`, operationScreen);
          // レスポンスがnullの場合は、ブラウザバックにて処理を中断しているので、APIがこれ以上継続しないためにreturnさせる
          if (this.imbEventLogListResult === null) {
            return;
          }
          if (this.isResponseDataCheck(this.imbEventLogListResult)) {
            this.createEventLogItemsImb();
            this.eventLogItems = this.eventLogItems.concat(this.imbEventLogListResult.data.event_logs);
          }
        }
      }

      // MAC鍵ポーリング処理
      if (this.macJobId) {
        const macEventLogListResponse = await this.getPollingEventLog(config.MAC, projectsId, this.macJobId, operationScreen);
        // レスポンスがnullの場合は、ブラウザバックにて処理を中断しているので、APIがこれ以上継続しないためにreturnさせる
        if (macEventLogListResponse === null) {
          return;
        }
        if (this.isResponseDataCheck(macEventLogListResponse)) {
          this.macEventLogListResult = await this.getCallApi(config.MAC, `${somePartApi}${this.macJobId}/results?region_info=${this.cachedProjectDataSource}`, operationScreen);
          // レスポンスがnullの場合は、ブラウザバックにて処理を中断しているので、APIがこれ以上継続しないためにreturnさせる
          if (this.macEventLogListResult === null) {
            return;
          }
          if (this.isResponseDataCheck(this.macEventLogListResult)) {
            this.createEventLogItemsMac();
            this.eventLogItems = this.eventLogItems.concat(this.macEventLogListResult.data.event_logs);
          }
        }
      }
    },

    /**
     * リプロイベントログの表に渡すItemの作成
     */
    createEventLogItemsRpr() {
      this.rprEventLogListResult.data.event_logs.forEach(element => {
        // イベントログ種別ごとにラベルを設定
        if (element.event_log_type === 'vehicleCom') {
          // 車両通信データラベル
          element.functionsName = this.$t('individual.label_vehicle_data_event_log_label');
        } else if (element.event_log_type === 'unitInternalInformation') {
          // ユニット内部情報ラベル
          element.functionsName = this.$t('individual.label_unit_internal_information_event_log_label');
        }
        element.logDateTime = util.timeConverter(element.end_date_time);
        element.buttonVisible = true;
        element.bgStyle = 'dtc-cursor-default'; // 一覧表示のカーソルを指マークにする
      });
    },

    /**
     * イモビイベントログの表に渡すItemの作成
     */
    createEventLogItemsImb() {
      this.imbEventLogListResult.data.event_logs.forEach(element => {
        // イモビライザ
        element.logDateTime = util.timeConverter(element.end_date_time);
        element.functionsName = this.$t('individual.label_immobilizer_event_log_label');
        // ダウンロード時にどのログを押下したかわからない為、明示的につける
        element.event_log_type = 'imb';
        element.buttonVisible = true;
        element.bgStyle = 'dtc-cursor-default'; // 一覧表示のカーソルを指マークにする
      });
    },

    /**
     * MAC鍵イベントログの表に渡すItemの作成
     */
    createEventLogItemsMac() {
      this.macEventLogListResult.data.event_logs.forEach(element => {
        // ユニット登録
        element.logDateTime = util.timeConverter(element.end_date_time);
        element.functionsName = this.$t('mac.label_mac_key');
        // ダウンロード時にどのログを押下したかわからない為、明示的につける
        element.event_log_type = 'unit';
        element.buttonVisible = true;
        element.bgStyle = 'dtc-cursor-default'; // 一覧表示のカーソルを指マークにする
      });
    },

    /**
     * イベントログGETAPI実行
     * @param {string} service 該当サービス
     * @param {string} endpoint API実行パス
     * @param {string} operationScreen operationScreen
     */
    async getCallApi(service, endpoint, operationScreen) {
      let response = null;
      const concatEventList = { Items: [] };
      if (operationScreen) {
        response = await api.getCall(service, endpoint, operationScreen);
      } else {
        response = await api.getCall(service, endpoint);
      }
      if (this.isResponseDataCheck(response)) {
        if (util.hasLastEvaluatedKey(response.data)) {
          concatEventList.Items = concatEventList.Items.concat(response.data.event_logs);
          response = await this.startPagingProcess(JSON.stringify(response.data.last_evaluated_key), service, endpoint, operationScreen, concatEventList);
        }
      }
      return response;
    },

    /**
     * last_evaluated_keyがある場合のGETAPI実行処理
     * @param {String} key last_evaluated_key
     * @param {String} service 該当サービス
     * @param {string} endpoint API実行パス
     * @param {string} operationScreen operationScreen
     * @param {Object} concatEventList イベントログリスト
     * @returns レスポンス
     */
    async startPagingProcess(key, service, endpoint, operationScreen, concatEventList) {
      const params = { last_evaluated_key: key };
      let resultResponse = null;
      let response = null;
      let endFlg = true;
      while (endFlg) {
        // 既に画面を離れている場合、while文のループから抜け出す
        if (this.isLeave) {
          return null;
        }
        if (operationScreen) {
          response = await api.getParamCall(service, endpoint, params, operationScreen);
        } else {
          response = await api.getParamCall(service, endpoint, params);
        }
        // 次のデータが存在するならループを継続、存在しないならページング処理を終了
        if (this.isResponseDataCheck(response)) {
          // レスポンスを詰める処理
          concatEventList.Items = concatEventList.Items.concat(response.data.event_logs);
          response.data.event_logs = concatEventList.Items;
          if (util.hasLastEvaluatedKey(response.data)) {
            params.last_evaluated_key = JSON.stringify(response.data.last_evaluated_key);
          } else {
            resultResponse = response;
            endFlg = false;
            break;
          }
        }
      }
      return resultResponse;
    },

    /**
     * イベントログ一覧/CSV生成ポーリング処理
     * @param {string} service 該当サービス
     * @param {string} projectsId プロジェクトID
     * @param {string} jobId ジョブID
     * @param {string} operationScreen operationScreen
     * @param {boolean} isCsv CSV生成ポーリングかどうか
     */
    async getPollingEventLog(service, projectsId, jobId, operationScreen, isCsv = false) {
      let currentRetry = 0;
      const retryMaxCount = Number(process.env.VUE_APP_RETRY_COUNT);
      let endFlg = true;
      let resultResponse = null;
      let response = null;
      const endpointType = isCsv ? 'exportEventLogs' : 'listEventLogs';

      while (endFlg) {
        // 既に画面を離れている場合、while文のループから抜け出す
        if (this.isLeave) {
          return null;
        }

        const endPoint = `/projects/${projectsId}/${endpointType}/jobs/${jobId}?region_info=${this.cachedProjectDataSource}`;
        // GET APIを呼び出す
        if (operationScreen) {
          response = await api.getCall(service, endPoint, operationScreen);
          currentRetry++;
        } else {
          response = await api.getCall(service, endPoint);
          currentRetry++;
        }
        if (response.data.status === config.EVENT_LOG_TYPE_SUCCESS || response.data.status === config.EVENT_LOG_TYPE_FAILED) {
          endFlg = false;
          resultResponse = response;
          break;
        }
        if (currentRetry >= retryMaxCount) {
          endFlg = false;
          resultResponse = response;
          break;
        }
        await util.sleep(process.env.VUE_APP_RETRY_INTERVAL);
      }
      return resultResponse;
    },

    /**
     * イベントログダウンロード
     * @param {Object} row イベントログ選択行
     */
    async downloadEventLog(row) {
      try {
        this.processing = true;
        const requestBody = {
          start_date_time: row.start_date_time,
          end_date_time: row.end_date_time,
          event_log_type: row.event_log_type,
          // リージョン情報をサーバーに通知（マスター/ミラー環境の識別）
          region_info: this.cachedProjectDataSource
        };
        let service = null;
        let operationScreen = null;
        const projectsId = this.projectDetails.id;
        const postApi = `/projects/${projectsId}/exportEventLogs/jobs`;
        if (row.event_log_type === 'vehicleCom' || row.event_log_type === 'unitInternalInformation') {
          service = config.DIAG;
          operationScreen = this.operationScreen;
        }
        if (row.event_log_type === 'imb') {
          service = config.IMB;
          delete requestBody.event_log_type;
        }
        if (row.event_log_type === 'unit') {
          service = config.MAC;
          delete requestBody.event_log_type;
        }
        const response = await api.postCall(service, postApi, requestBody, operationScreen);
        if (this.isResponseDataCheck(response)) {
          const downloadPathResponse = await this.getPollingEventLog(service, projectsId, response.data.id, operationScreen, true);
          // レスポンスがnullの場合は、ブラウザバックにて処理を中断しているので、APIがこれ以上継続しないためにreturnさせる
          if (downloadPathResponse === null) {
            return;
          }
          if (this.isResponseDataCheck(downloadPathResponse)) {
            this.url = downloadPathResponse.data.csv_path;
          }
        }
      } finally {
        this.processing = false;
      }
    },

    /** イベントログ一覧取得に必要な関数を呼び出す */
    async processingEventLog() {
      // ジョブID発行
      if (await this.createJobId()) {
        // ポーリング（非同期処理）
        await this.pollingProcess();
      }
    },

    /**
     * 特殊なシステム名を翻訳する
     */
    getMultipleDMSystemName: async function () {
      // マルチデータモニタのデータが存在する場合
      if (Array.isArray(this.mltDmMeasuresData)) {
        // 一覧のシステム名を再翻訳する
        this.mltDmMeasuresData.forEach(item => {
          item.system = item.systemIds.map(id => {
            return `${this.$t('diagSytem.' + id)} (${dmUtil.getAbbrSysName(id)})`;
          }).join('/');
        });
      }
    },

    /**
     * ファイルエクスポートボタン押下時の処理
     */
    async csvExport(row) {
      let csvWriter = null;
      try {
        this.showCsvProgress = true;
        this.exportPercentage = 0;

        const FILE_INFO_MAP = {
          'dm': { data: this.indDmMeasuresData, functionName: this.$t('individual.individual_diagnosis_function_data_monitor') },
          'at': { data: this.atMeasuresData, functionName: this.$t('individual.individual_diagnosis_function_active_test') },
          'multiple_dm': { data: this.mltDmMeasuresData, functionName: this.$t('message.label_menu_multi_data_monitor') },
          'data_monitor': { data: this.obdDataMonitorMeasuresData, functionName: `${this.$t('fixed_resource.obd_menu_datamonitor')}${this.$t('fixed_resource.obd_menu')}` }
        };
        const targetMeasurement = FILE_INFO_MAP[row.function_name].data.find(measurement => measurement.registered_at === row.registered_at);
        const fileName = getMeasurementFileName(targetMeasurement.name ?? '', FILE_INFO_MAP[row.function_name].functionName, this.cachedDetails.information.vin ?? '');

        // FileSystemApiはセキュリティ上ユーザー操作時のみ使用可能なため、ファイルエクスポート押下直後にインスタンス作成
        csvWriter = new CsvFileWriter(fileName);
        await csvWriter.init();

        // DOMを生成し、データの取得を行う
        // 直前エクスポートしたものをもう一度エクスポートする場合、データの取得を行わない
        if (!this.selectedRow || JSON.stringify(row) !== JSON.stringify(this.selectedRow)) {
          this.selectedRow = row;
          // data-recollection の DOM を削除
          this.activeDataRecollection = false;
          // refによる参照がなくなるまで待つ
          while (this.$refs.data_recollection) {
            await util.sleep(500);
          }
          // キャッシュ情報を設定
          this.projectDetails.comment = this.originalComment;
          this.projectDetails.vinType = this.vinType;
          const allMeasuresData = [{
            repro: this.reproDetailsData, vch: this.vchMeasuresData, cst: this.cstMeasuresData, cnc: this.cncMeasuresData,
            wsp: this.wspMeasuresData, dmat: this.dmatDetailsData, obd: this.obdDetailsData
          }];
          this.cacheProjectDetails({ information: this.projectDetails, measures: allMeasuresData });

          // data-recollectionのプロパティを設定
          this.allMeasuresData = JSON.stringify(allMeasuresData);
          this.measuredIdProp = row.registered_at;
          this.isActive = JSON.stringify(this.activeLabel);
          this.systemName = row.system;
          this.systemIds = row.systemIds;
          this.itemNameProp = row.item_name;
          this.obdDataIdProp = row.obdDataId;
          this.obdSystemsProp = JSON.stringify(row.obdSystems);

          // data-recollection の DOM を生成
          this.activeDataRecollection = true;
          // refによる参照待ち
          while (!this.$refs.data_recollection) {
            await util.sleep(500);
          }

          // データ取得完了待ち
          while (!this.$refs.data_recollection.checkCsvExport(this.activeLabel)) {
            await util.sleep(500);
          }
        }
        await this.$refs.data_recollection.executeCsvExport(this.activeLabel, csvWriter);
      } catch (error) {
        if (CsvFileWriter.isUserCancel(error)) {
          // ユーザーがCSVの書き込みをキャンセルしたら何もせず終了
          return;
        }
        throw error;
      } finally {
        this.showCsvProgress = false;
        csvWriter && await csvWriter.close();
      }
    },

    /**
     * CSVエクスポートの進捗を更新する
     * @param {number} percentage 進捗率
     */
    updateExportPercentage(percentage) {
      this.exportPercentage = percentage;
    },

    /**
     * ヘッダーに表示する計測データの取得元の環境(マスター/ミラー)を設定
     */
    setDataSourceHeader() {
      if (this.cachedProjectDataSource === constants.MAINTENANCE_ACTIVE_ENV_DEFAULT) {
        this.dataSourceHeader = { name: 'dataSource', label: this.$t('message.header_measured_data_details_datasource_master') };
      } else {
        this.dataSourceHeader = { name: 'dataSource', label: this.$t('message.header_measured_data_details_datasource_mirror') };
      }
    }
  },

  computed: {
    ...mapState({
      language: state => state.systems.language,
      cachedDetails: state => state.cache.projectDetails,
      cachedProjects: state => state.cache.projectListBuff,
      companyId: state => state.userProperty.companyId,
      cachedProjectDataSource: state => state.cache.projectDataSource,
      isMovedVehicleToProject: state => state.cache.isMovedVehicleToProject,
    }),
    // 診断系のAPIは複数画面から使用されているため
    // 現在の画面で使用されるAPIが診断/データ再生/個別診断のうちどの機能なのか判別する
    operationScreen() {
      return diagnoResource.operationFrom(this.$router.currentRoute.value.name);
    },

    /** イベントログのcolumnsをactiveなタブによって返却する */
    eventLogColumns() {
      return [
        { name: 'logDateTime', label: 'individual.label_event_log_table_log_date' },
        { name: 'functionsName', label: 'individual.label_event_log_table_function' },
        { name: 'download', label: 'message.button_home_download_cc', useButton: true }
      ];
    },

    /**
     * 現在アクティブな機能のキーを取得する
     * @returns {string} 機能のキー
     */
    currentFunctionKey() {
      for (const keys in this.activeLabel) {
        if (this.activeLabel[keys]) {
          return keys;
        }
      }

      return null;
    },
  },

  created() {
    this.clearAlert();
    this.setNavTabLabel();
    if (this.isActiveLabel) {
      this.activeLabel = JSON.parse(this.isActiveLabel);
    }
  },

  async mounted() {
    this.isLeave = false;
    // SBRユーザーかチェック
    this.isSBRUser = await this.checkSBRUser(this.companyId);
    // キャッシュがなければ計測データ一覧を取得
    this.projectDetails = JSON.parse(JSON.stringify(this.cachedDetails.information));
    this.originalComment = this.cachedDetails.information.comment;
    const tmpMeasures = await this.cachedDetails.measures || [];
    if (tmpMeasures.length < 1) {
      await this.setupMeasuredData();
    } else {
      await this.changeDetailData(tmpMeasures[0]);
      if (this.isSBRUser) {
        this.processing = true;
        // イベントログ一覧取得(SBRユーザーのみ実行)
        await this.processingEventLog();
        this.processing = false;
      }
    }
    this.setDataSourceHeader();
  },

  beforeRouteLeave(to, from, next) {
    if (to.name === 'home' && this.isMovedVehicleToProject) {
      // 実行系⇒プロジェクト画面への遷移済フラグ true 且つ、Start押下の場合、確認ダイアログを表示し、OKボタン押下で何もしない。
      alert.showConfirmation(this, null, this.$t('message.label_confirm_message_not_move_home'), null, null, null, true);
      next(false);
    } else {
      this.isLeave = true;
      next();
    }
  }
};
